import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ThemeSwitch } from '@helpers/theme';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import { transparentize } from 'polished';
import styled from 'styled-components';
const Wrapper = styled.div `
  // Needed for the horizontal scroll table
  overflow: auto;
  line-height: normal;

  h1,
  h2 {
    ${HeadingStyles.H5Styles};
    ${ThemeSwitch({ groundforceColour: brand.primary.alt })}
    color: var(--theme);
  }

  p {
    ${ParagraphStyles.RegularStyles};
  }

  a {
    ${ThemeSwitch({ groundforceColour: brand.primary.alt })}
    color: var(--theme);
  }

  table {
    table-layout: auto !important;
    min-width: 700px;
    width: 100% !important;
    height: auto !important;

    thead {
      tr {
        background: ${brand.grey.grey35} !important;
      }
    }

    tbody {
      tr {
        background-color: ${brand.grey.grey96} !important;

        &:nth-child(odd) {
          ${ThemeSwitch({
    groundforceColour: 'rgba(102, 153, 0, 0.12)',
    tpaColour: transparentize(0.88, brand.tpa.base),
})}
          background-color: var(--theme) !important;
        }
      }
    }

    th,
    td {
      padding: 12px 20px !important;
      height: auto !important;
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      vertical-align: middle !important;

      @media ${from(Device.DesktopLarge)} {
        padding: 12px 34px !important;
      }
    }

    th:not([colspan]),
    td:not([colspan]) {
      min-width: 216px !important;
    }

    td {
      color: ${brand.black} !important;

      border-right: 1px solid ${brand.grey.grey44} !important;
      &:last-child {
        border-right: none !important;
      }
    }

    th {
      ${fonts.DaxPro.Bold};
      color: ${brand.white} !important;
      font-size: 20px !important;
    }
  }

  iframe {
    min-height: 900px;
  }

  &[data-hidden='true'] {
    display: none;
  }
`;
export const WYSIWYGStyles = {
    Wrapper,
};
